module.exports = __webpack_public_path__ + "assets/RTrBy2SidePointsDetailed.fc70031cd621529237e72192c398d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/RTrBy2SidePointsDetailed.png
// module id = 553
// module chunks = 0